export default {
  Title: {
    FAVoucherIncreament: 'Chọn tài sản ghi tăng từ MISA QLTS',
    FAVoucherDecrement: 'Chọn tài sản ghi giảm từ MISA QLTS',
    FAVoucherDepreciation: 'Chọn tài sản tính hao mòn từ MISA QLTS',
    FAVoucherAdjustment: 'Chọn chứng từ điều chỉnh từ MISA QLTS',
  },
  DateRange: {
    All: 'Tất cả',
    Custom: 'Ngày chứng từ trong khoảng',
    From: 'Từ',
    To: 'Đến',
    GetData: 'Lấy dữ liệu',
  },
  Button: {
    Cancel: 'Huỷ bỏ',
    Action: 'Thực hiện',
    ActionTooltip: 'Thực hiện (Ctrl + S)',
  },
};
